let notesDiv = document.getElementById("notes");

let notesDivElement = document.createElement("div");
notesDivElement.innerHTML = "Some cells are not available due to suppression.";

notesDiv.appendChild(notesDivElement);
